import React, { useEffect, useState } from 'react';
import { Col, Row } from 'reactstrap';
import PropTypes from 'prop-types';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, Input, InputLabel, MenuItem, Rating, Select, TextField, TextareaAutosize, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
//import OneDriveTeste from '../OneDriveTeste/OneDriveTeste';
import moment from 'moment';
import { getProdutoFinal, insert, notifyByEmail, update, getZipAndSaveInOikos, verificaPastaProdFinal, getProdCoordenadorPfId } from '../../../utils/fc/index.js';
import { Spinner } from 'reactstrap';
import { notifyError, notifySuccess } from '../../../utils/notify'




const ModalFormCorrecaoInterna = ( {dataContratual, tecResp, ...props} ) => {

    const [open, setOpen] = useState(false);
    const [obsTec, setObsTec] = useState('');
    const [isStatusLoading, setIsStatusLoading] = useState(false);
    const [openModalErro, setOpenModalErro] = useState(false);
    const [parecerRev, setParecerRev] = useState([]);

    const { prod_id, proj_id } = useParams();

    const handleClickOpen = () => {
    setOpen(true);
    };

    const handleClose = () => {
    setOpen(false);
    };


    const handleChangeObs = (event) => {
        setObsTec(event.target.value);
    };

    useEffect(()=>{
      try {
        const arrayOfObjects = JSON.parse(props.prodStatusAlt_obs);
        setParecerRev(arrayOfObjects);
      } catch {
        setParecerRev([props.prodStatusAlt_obs]);

      }
    }, [])

    return (
        <>
            <Button variant="" onClick={handleClickOpen}>
                Corrigir
            </Button>
            <Dialog
            fullWidth
            maxWidth= 'sm'
            open={open}
            onClose={handleClose}
            PaperProps={{
            component: 'form',
            onSubmit: async (event) => {
                setIsStatusLoading(true);
                event.preventDefault();
                const formData = new FormData(event.currentTarget);
                const formJson = Object.fromEntries(formData.entries());
                const verificaPastaVazia = await verificaPastaProdFinal(props.produto.prod_drive);
                if (verificaPastaVazia) {
                  const penultimo = Number(props.produto.prodStatusPenultimo_id)
                  if (penultimo < 3 || penultimo > 8) {
                    notifyError('Não foi possível identificar a etapa anterior à correção.');
                    setIsStatusLoading(false);
                    return;
                  }
                  await getZipAndSaveInOikos(props.produto.prod_drive, props.produto);
                  const inserted = await insert('prodStatusAlt', {prod_id: props.produto.prod_id, prodStatusTp_id: 4, pf_id: getProdCoordenadorPfId(props.produto), prodStatusAlt_obs: formJson.input_obs, prodStatusAlt_data: moment().format('YYYY-MM-DD'), prodStatusAlt_usuarioCria: props.userOikosId, prodStatusAlt_usuarioMod: props.userOikosId});
                  if (!inserted) {
                    notifyError('Não foi possível registrar a correção.');
                    setIsStatusLoading(false);
                    return;
                  }
                  await notifyByEmail(props.produto.prod_id, {obs: obsTec})
                  notifySuccess('Produto Corrigido!');
                  console.log('Corrigido')
                  setIsStatusLoading(false);
                  handleClose();
                  props.setCount(prevState => prevState + 1);
                  if (props.onProductTimelineChanged) props.onProductTimelineChanged();
                } else {
                  setIsStatusLoading(false);
                  setOpenModalErro(!openModalErro);
                  handleClose();
                }

                /*
                const fileProdFinal = await getProdutoFinal(props.produto.prod_drive, "admin@ecossis.com.br", props.produto.prod_formato);
                if (!fileProdFinal) {
                    setIsStatusLoading(false);
                    setOpenModalErro(!openModalErro);
                    handleClose();
                } else {
                    if (props.produto.prodStatusPenultimo_id === 3) {
                        await insert('prodStatusAlt', {prod_id: props.produto.prod_id, prodStatusTp_id: 4, pf_id: getProdCoordenadorPfId(props.produto), prodStatusAlt_obs: formJson.input_obs, prodStatusAlt_data: moment().format('YYYY-MM-DD'), prodStatusAlt_usuarioCria: props.userOikosId, prodStatusAlt_usuarioMod: props.userOikosId});
                        await notifyByEmail(props.produto.prod_id, {obs: obsTec})
                    }
                    if (props.produto.prodStatusPenultimo_id === 4) {
                        await insert('prodStatusAlt', {prod_id: props.produto.prod_id, prodStatusTp_id: 4, pf_id: getProdCoordenadorPfId(props.produto), prodStatusAlt_obs: formJson.input_obs, prodStatusAlt_data: moment().format('YYYY-MM-DD'), prodStatusAlt_usuarioCria: props.userOikosId, prodStatusAlt_usuarioMod: props.userOikosId});
                        await notifyByEmail(props.produto.prod_id, {obs: obsTec})
                    }
                    if (props.produto.prodStatusPenultimo_id === 6) {
                        await insert('prodStatusAlt', {prod_id: props.produto.prod_id, prodStatusTp_id: 4, pf_id: getProdCoordenadorPfId(props.produto), prodStatusAlt_obs: formJson.input_obs, prodStatusAlt_data: moment().format('YYYY-MM-DD'), prodStatusAlt_usuarioCria: props.userOikosId, prodStatusAlt_usuarioMod: props.userOikosId});
                        await update('prod', props.produto.prod_id, {prod_dtEntrega: moment().format('YYYY-MM-DD')} );
                        await notifyByEmail(props.produto.prod_id, {obs: obsTec})
                    }
                    notifySuccess('Produto Corrigido!');
                    console.log('Corrigido')
                    setIsStatusLoading(false);
                    handleClose();
                    props.setCount(prevState => prevState + 1);
                };

                */
            },
            }}
            >
            <DialogTitle>Correção do produto</DialogTitle>
            <DialogContent>
            <div className="d-flex justify-content-between">
                <div className='d-flex flex-column pt-4 flex-fill'>
                    <div className="d-flex justify-content-between mb-3">
                        <div>
                            <span>Técnico Responsável</span>
                            <h6>{tecResp}</h6>
                        </div>
                        <div>
                          <span>Data contratual</span>
                          {(moment(dataContratual, 'DD/MM/YYYY').toDate().getTime() > Date.now()) ? <h6 className='text-success'>{dataContratual}</h6> : <h6 className='text-danger'>{dataContratual}</h6>}
                        </div>
                        <div>
                          <span>Data Entrega</span>
                          {props.dataEntregueAGestao && !props.dataEntregueAoEp &&
                            moment(props.dataEntregueAGestao, 'DD/MM/YYYY').toDate().getTime() > new Date(props.produto.prod_dtInterna).getTime()
                            && <h6 className='text-success'>{props.dataEntregueAGestao}</h6>}
                          {props.dataEntregueAGestao && !props.dataEntregueAoEp &&
                            moment(props.dataEntregueAGestao, 'DD/MM/YYYY').toDate().getTime() < new Date(props.produto.prod_dtInterna).getTime()
                            && <h6 className='text-danger'>{props.dataEntregueAGestao}</h6>}
                          {props.dataEntregueAoEp &&
                            moment(props.dataEntregueAoEp, 'DD/MM/YYYY').toDate().getTime() > new Date(props.produto.prod_dtInterna).getTime()
                            && <h6 className='text-success'>{props.dataEntregueAoEp}</h6>}
                          {props.dataEntregueAoEp &&
                            moment(props.dataEntregueAoEp, 'DD/MM/YYYY').toDate().getTime() < new Date(props.produto.prod_dtInterna).getTime()
                            && <h6 className='text-danger'>{props.dataEntregueAoEp}</h6>}
                        </div>
                    </div>
                    {props.produto.prodStatusPenultimo_id === 3 && (
                      <div>
                        <span>Parecer da Revisão:</span><br/>
                        {parecerRev.map((item) =>
                          (
                            <div className='mb-2'>
                              <span style={{fontWeight: '600'}}>Item {item.obsNum}</span><br/>
                              <span>Observação: {item.observacao}</span><br/>
                              <span>Página: {item.pagina}</span><br/>
                            </div>
                          )
                        )}
                      </div>
                      )
                    }
                    {(props.produto.prodStatusPenultimo_id === 4 || props.produto.prodStatusPenultimo_id === 6) &&
                      <div className="d-flex justify-content-between mb-3">
                        <div>
                            <span>Observações da gerência técnica:</span>
                            <h6>{props.prodStatusAlt_obs}</h6>
                        </div>
                      </div>
                    }
                    <span>Observação técnica:</span>
                    <TextareaAutosize
                        placeholder='Observações'
                        margin="dense"
                        id="input_obs"
                        name="input_obs"
                        label="Aqruivo"
                        variant="standard"
                        className='mb-3 p-1'
                        onChange={handleChangeObs}
                    />

                    <a target='_blank' href={`${props.produto.prod_drive}`}>Link para a pasta do produto</a>
                    {/*
                    <Input
                        autoFocus
                        margin="dense"
                        id="input_file"
                        name="input_file"
                        label="Aqruivo"
                        type="file"
                        variant="standard"
                        required
                    />
                    */}
                </div>
            </div>
            </DialogContent>
            <DialogActions>
                {isStatusLoading && (
                    <Button
                    autoFocus
                    margin="dense"
                    id="entregaRevInterna"
                    name="entrega_rev_interna"
                    label="Entrega a Revisao Interna"
                    type="submit"
                    variant="outlined"
                    disabled
                    endIcon={<Spinner/>}
                    >Aguarde</Button>
                )}
                {!isStatusLoading && (
                    <>
                        <Button onClick={handleClose}>Cancelar</Button>
                        <Button type="submit">Corrigir</Button>
                    </>
                )}
            </DialogActions>
            </Dialog>
        </>
    )
}

ModalFormCorrecaoInterna.propTypes = {
dataContratual: PropTypes.string,
tecResp: PropTypes.string,
};

export default ModalFormCorrecaoInterna;
